import React, { useEffect, useState } from 'react';
import { get } from '../common/httpService';
import common from '../common/common';
import {
  filter,
  find,
  includes,
  isEmpty,
  isNil,
  join,
  map,
  replace,
  slice,
  split,
  toLower,
  trim,
  some,
  startsWith,
} from 'lodash';
import translateService from '../common/translateService';

import './DesktopMenu.scss';
import marketingAndAnalyticsService from '../services/marketingAndAnalytics/marketingAndAnalyticsService';
import { logError } from '../tracing';

const DesktopMenu = (props) => {
  const [isLoading, setLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState({
    dropdown: false,
    tertiary: false,
  });
  const [siteInfo, setSiteInfo] = useState({
    siteName: common.getSite(),
    categoryToOpenMenuIds: [],
    homepage:
      window.location.protocol +
      '//' +
      window.location.hostname +
      window.$pathBase,
  });
  const [items, setItems] = useState({
    primary: [],
    secondary: [],
    tertiary: [],
  });
  const [selectedItem, setSelectedItem] = useState({});

  useEffect(() => {
    const categoryMapping = {
      lordgun: [0],
      runkd: [227, 280, 393, 476],
      inwild: [537, 697, 913, 1123],
    };
    const categoryIds =
      categoryMapping[siteInfo.siteName] !== undefined
        ? categoryMapping[siteInfo.siteName]
        : [];

    setSiteInfo((prevState) => ({
      siteName: prevState.siteName,
      categoryToOpenMenuIds: categoryIds,
    }));

    initialize();
  }, []);

  const initialize = async () => {
    let result = null;
    try {
      result = await get({
        url: `menu/MenuHeaderDesktopJson`,
      });
      if (result !== null) {
        let foundItem = getSelectedItem(result.children, result.products);

        if (isNil(foundItem)) {
          foundItem = {};
        }
        setSelectedItem(foundItem);

        const primaryItems = getItemsWithUpdatedSelection(
          result.children,
          foundItem,
        );

        const secondaryItems = map(result.products, (i) => ({
          ...i,
          isActive: false,
        }));

        setItems((prevState) => ({
          primary: primaryItems,
          secondary: secondaryItems,
          tertiary: prevState.tertiary,
        }));
      }
    } catch (error) {
      console.error('Error calling menu/MenuHeaderDesktopJson', error);
      logError(error);
    }
    setLoading(false);
  };

  const getSelectedItem = (firstLevel, secondLevel) => {
    const location = window.location.toString();
    const isHomepage = location === siteInfo.homepage;

    if (isHomepage) return undefined;

    let foundItem = find(firstLevel, (i) => {
      const targetString =
        window.$pathBase.length === 1
          ? i.link
          : split(
              i.link,
              join(slice(window.$pathBase, 0, window.$pathBase.length - 1), ''),
            )[1];
      return includes(location, targetString);
    });
    if (isNil(foundItem) && !isEmpty(secondLevel)) {
      let foundChild = getSelectedItem(secondLevel, []);
      foundItem = isNil(foundChild) ? undefined : firstLevel[0];
    }

    return foundItem;
  };

  const getItemsWithUpdatedSelection = (collection, item) =>
    map(collection, (c) => ({
      ...c,
      isActive: c.id === item.id,
    }));

  const closeDropdown = () => {
    setMenuOpen({
      dropdown: false,
      tertiary: false,
    });
    setItems((prevState) => ({
      primary: getItemsWithUpdatedSelection(items.primary, selectedItem),
      secondary: prevState.secondary,
      tertiary: [],
    }));
  };

  const handleDropdownClick = async (i, e) => {
    e.preventDefault();
    try {
      if (!includes(siteInfo.categoryToOpenMenuIds, Number(i.id))) {
        const linkUrl = i.link;
        await marketingAndAnalyticsService.recordCategoryClick({
          linkUrl,
        });
        window.location.href = startsWith(linkUrl, 'http')
          ? linkUrl
          : window.location.origin + linkUrl;
        return;
      }
      const dropdown = document.querySelector('.desktop-dropdown-container');

      if (!isNil(dropdown)) {
        if (menuOpen.dropdown) {
          // su runkd potrei voler cambiare categoria di primo livello
          if (siteInfo.siteName !== 'lordgun') {
            if (i.isActive) {
              closeDropdown();
            } else {
              closeDropdown();
              const newPrimary = getItemsWithUpdatedSelection(items.primary, i);
              setItems({
                primary: newPrimary,
                secondary: i.children,
                tertiary: [],
              });

              window.setTimeout(() => {
                setMenuOpen({
                  dropdown: true,
                  tertiary: false,
                });
              }, 300);
            }
            // voglio chiudere il menu
          } else {
            closeDropdown();
          }
        }
        // voglio aprire il menu
        else {
          const newPrimary = getItemsWithUpdatedSelection(items.primary, i);
          const newSecondary = getItemsWithUpdatedSelection(
            items.secondary,
            {},
          );
          if (siteInfo.siteName !== 'lordgun') {
            setItems({
              primary: newPrimary,
              secondary: i.children,
              tertiary: [],
            });
          } else {
            setItems({
              primary: newPrimary,
              secondary: newSecondary,
              tertiary: [],
            });
          }

          dropdown.style.top =
            document.getElementById('main-header').offsetHeight + 'px';
          setMenuOpen({
            dropdown: true,
            tertiary: false,
          });
        }
      }
    } catch (error) {
      logError(error);
    }
  };

  const handleClickSecondary = async (i, e) => {
    e.preventDefault();
    try {
      // è chiuso, voglio mostrare le categorie di terzo livello
      // devo:
      // 1. settare i tertiary
      // 2. settare la secondary attiva
      if (!menuOpen.tertiary) {
        if (isEmpty(i.children)) {
          let linkUrl = i.link;
          await marketingAndAnalyticsService.recordCategoryClick({
            linkUrl,
          });
          window.location = linkUrl;
        }

        const newSecondary = getItemsWithUpdatedSelection(items.secondary, i);
        setItems((prevState) => ({
          primary: prevState.primary,
          secondary: newSecondary,
          tertiary: i.children,
        }));

        setMenuOpen({
          dropdown: true,
          tertiary: true,
        });
      }
      // sto già mostrando le categorie di terzo livello:
      // se ho cliccato una categoria di secondo livello NON attiva (= un'altra cat)
      // => mostro i suoi figli
      // se ho cliccato quella attiva (= la stessa)
      // => redirect su pagina
      else {
        if (isEmpty(i.children) || i.isActive) {
          let linkUrl = i.link;
          await marketingAndAnalyticsService.recordCategoryClick({
            linkUrl,
          });
          window.location = linkUrl;
        } else {
          setMenuOpen({
            dropdown: true,
            tertiary: false,
          });
          const newSecondary = getItemsWithUpdatedSelection(items.secondary, i);
          setItems((prevState) => ({
            primary: prevState.primary,
            secondary: newSecondary,
            tertiary: i.children,
          }));

          window.setTimeout(() => {
            setMenuOpen({
              dropdown: true,
              tertiary: true,
            });
          }, 300);
        }
      }
    } catch (error) {
      logError(error);
    }
  };

  const getCleanNames = (name) => {
    if (isNil(name)) return '';

    const n = filter(name, (char) => char === ' ');
    if (isNil(n) || isEmpty(n) || n.length <= 0) return name;

    let cleanName = name;

    for (let i = 0; i < n.length; i++) {
      cleanName = replace(cleanName, ' ', '-');
    }

    return cleanName;
  };

  const primaryLinks = map(items.primary, (i) => (
    <a
      className={trim(
        `desktop-nav--link ${i.cssClass} ${
          i.id === 227 || i.id === 280 ? 'bold' : ''
        } ${i.isActive ? 'is-selected' : ''}`,
      )}
      id={toLower(getCleanNames(i.name))}
      href={i.link}
      key={i.id}
      onClick={(e) => handleDropdownClick(i, e)}
    >
      {i.name}
    </a>
  ));

  const secondaryLinks = map(items.secondary, (i) => (
    <a
      className={`desktop-dropdown--links-link ${i.cssClass} ${
        i.isActive ? 'isActive' : ''
      }`.trim()}
      id={toLower(getCleanNames(i.name))}
      href={i.link}
      key={i.id}
      onClick={(e) => handleClickSecondary(i, e)}
    >
      {i.name}
    </a>
  ));

  const openTertiaryLinks = async (event, i) => {
    event.preventDefault();
    try {
      const linkUrl = i.link;
      await marketingAndAnalyticsService.recordCategoryClick({
        linkUrl,
      });
      window.location.href = linkUrl;
    } catch (error) {
      logError(error);
    }
  };

  const tertiaryLinks = map(items.tertiary, (i) => (
    <a
      className={`desktop-dropdown--links-tertiary-link ${
        i.isViewAllLink ? 'show-all--link' : ''
      }`.trim()}
      key={i.id}
      href={i.link}
      onClick={(e) => openTertiaryLinks(event, i)}
    >
      {i.name}
    </a>
  ));

  let prevPosition = window.scrollY;
  window.addEventListener('scroll', () => {
    if (menuOpen.dropdown) {
      let currentPosition = window.scrollY;

      if (currentPosition > prevPosition) {
        closeDropdown();
      }
      prevPosition = currentPosition;
    }
  });

  document.querySelector('body').addEventListener(
    'onclick',
    (e) => {
      if (menuOpen.dropdown) {
        const topElement = document.querySelector('.wrapper.wrapper--main');
        const desktopMenu = document.querySelector('#desktopMenu');

        if (!isNil(e.target)) {
          let element = e.target;
          while (element !== topElement && !isNil(element)) {
            if (element === desktopMenu) {
              return;
            }
            element = element.parentNode;
          }
          closeDropdown();
        }
      }
    },
    { passive: true },
  );

  const showAll = async (event) => {
    event.preventDefault();
    try {
      if (some(items.primary, (i) => i.isActive)) {
        const linkUrl = find(items.primary, (i) => i.isActive).link;
        await marketingAndAnalyticsService.recordCategoryClick({
          linkUrl,
        });
        window.location.href = linkUrl;
      }
    } catch (error) {
      logError(error);
    }
  };

  return isLoading ? (
    <></>
  ) : (
    <>
      <nav className='desktop-nav'>{primaryLinks}</nav>
      <div
        className={`desktop-dropdown-container ${
          menuOpen.dropdown ? 'is-open' : ''
        }`.trim()}
      >
        <div className='desktop-dropdown--show-all'>
          <a className='show-all--link' href={''} onClick={showAll}>
            <strong>{translateService.get(`common.showAll`)}</strong>
          </a>
        </div>
        <div className='desktop-dropdown-box'>
          <div className='desktop-dropdown--links'>
            <div className='desktop-dropdown--links-secondary'>
              {secondaryLinks}
            </div>
            <div
              className={`desktop-dropdown--links-tertiary ${
                menuOpen.tertiary ? 'is-open' : ''
              }`.trim()}
            >
              {tertiaryLinks}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DesktopMenu;
